import React from 'react';
import styled from '@emotion/native';
import { Linking, TextStyle, StyleProp } from 'react-native';
import { green } from '@/shared/styles/colors';
import { BodyText } from '@/shared/components/StyledText';
import { EMME_SUPPORT_EMAIL } from '@/shared/constants/utility';

interface EmailLinkProps {
  children?: React.ReactNode;
  style?: StyleProp<TextStyle>;
}

const EmailLink = ({ children, style }: EmailLinkProps): React.ReactNode => {
  const handlePress = () => {
    Linking.openURL(`mailto:${EMME_SUPPORT_EMAIL}`);
  };

  return (
    <StyledLink onPress={handlePress} style={style}>
      {children}
    </StyledLink>
  );
};

const StyledLink = styled(BodyText)({
  color: green,
});

export default EmailLink;
